import { createContext, useState } from "react";

export const NotificationEventContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [notificationEvents, setNotificationEvents] = useState([]);
    const [notificationEvent, setNotificationEvent] = useState(null);
    const [notificationEventDialog, setNotificationEventDialog] = useState(false);

    // Make the context object:
    const notificationEventContext = {
        notificationEvents,
        setNotificationEvents,
        notificationEvent,
        setNotificationEvent,
        notificationEventDialog,
        setNotificationEventDialog,
    };

    // pass the value in provider and return
    return <NotificationEventContext.Provider value={notificationEventContext}>{children}</NotificationEventContext.Provider>;
};

export const { Consumer } = NotificationEventContext;
